import { useQuery } from '@tanstack/react-query';
import { eventsApi } from '../api/events';

export const useEventsByBrg = (brgId: number | null | undefined) => {
  return useQuery({
    queryKey: ['eventsByBrg', brgId],
    queryFn: () => (brgId ? eventsApi.list(brgId) : Promise.resolve([])),
    enabled: !!brgId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
  });
};

export const useAllEvents = () => {
  return useQuery({
    queryKey: ['allEvents'],
    queryFn: () => eventsApi.list(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
  });
};

export const useEventById = (eventId: number | null) => {
  return useQuery({
    queryKey: ['event', eventId],
    queryFn: () => (eventId ? eventsApi.getById(eventId) : Promise.resolve(null)),
    enabled: !!eventId,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
};
